import { AlertCircle } from 'lucide-react';

import { formatCurrency } from '../../constants/i18n';
import { t } from '../../constants/i18n';
import type { CartInfoTip } from '../../hooks/cart/useCartInfo';
import { MarqueeText } from './MarqueeText';

interface OrderThresholdTipProps {
  tip: CartInfoTip;
  currency: string;
}

// 独立的订单门槛提示组件（最低订单）
export function OrderThresholdTip({ tip, currency }: OrderThresholdTipProps) {
  const threshold = typeof tip.thresholdCents === 'number' ? tip.thresholdCents : 0;
  const message = t('minOrder', formatCurrency(threshold, currency));

  return (
    <span className="flex items-center justify-center w-full min-w-0">
      <span className="inline-flex items-center gap-2 leading-none min-w-0 w-full">
        <AlertCircle className="w-4 h-4 shrink-0 text-orange-500" />
        <span className="flex-1 min-w-0">
          <MarqueeText className="text-sm font-medium text-zinc-700">
            {message}
          </MarqueeText>
        </span>
      </span>
    </span>
  );
}
